import React from 'react'
import PageTitle from '../components/PageTitle'
import Link from '../components/Link'
import Layout from '../components/Layout'
import '../components/Layout/layout.css'

const PublicReports = () => (
  <Layout>
    <PageTitle name="OIRA Public Reports" site="OIRA" />

    {/* <h3>Advising Survey</h3> */}
    <div className="reports">
      <p>
        <span className="b">Advising Survey Overview</span> - This survey assesses student perceptions regarding the advising process and utilization of advising tools at The University of Alabama. Authorized users can access additional Advising Survey results for their college/school through a log in option.  Available reports are listed below.
      </p>
      <ul className="list-one">
        <li>
          <a className="b" href="https://reports.oira-ua.tech/r/advising-survey/report/202510" target="_blank" rel="noopener noreferrer">Spring 2025</a>
        </li>
        <li>
          <a className="b" href="https://reports.oira-ua.tech/r/advising-survey/report/202410" target="_blank" rel="noopener noreferrer">Spring 2024</a>
        </li>
        <li>
          <a className="b" href="https://reports.oira-ua.tech/r/advising-survey/report/202310" target="_blank" rel="noopener noreferrer">Spring 2023</a>
        </li>
      </ul>
      <ul className="list-two">
        <li>
          <a className="b" href="https://reports.oira-ua.tech/r/advising-survey/report/202210" target="_blank" rel="noopener noreferrer">Spring 2022</a>
        </li>
        <li>
          <a className="b" href="https://reports.oira-ua.tech/r/advising-survey/report/202110" target="_blank" rel="noopener noreferrer">Spring 2021</a>
        </li>
      </ul>
    </div>

    {/* <h3>Census Enrollment</h3> */}
    <div className="reports">
      <a className="b" href="https://app.powerbi.com/view?r=eyJrIjoiNzA4NjM3YzktMjllOC00OTNkLWFlODktMjUxYjdjYzVjMzllIiwidCI6IjJhMDA3MjhlLWYwZDAtNDBiNC1hNGU4LWNlNDMzZjNmYmNhNyIsImMiOjN9" target="_blank" rel="noopener noreferrer">Census Enrollment Report</a> - This report provides enrollment information by student level, campus, college/school, Alabama County, and State. The report is updated after then census date for the term and provides an early look at the University’s official enrollments. This report is adapted from reports previously produced by the Office of the University Registrar (OUR) prior to fall 2008.  For additional enrollment information and much more, please see the OIRA interactive <a className="b" href="https://oira.ua.edu/new/interactiveFB/">Factbook</a>.
    </div>
    
    {/* <h3>Minority Participation</h3> */}
    <div className="reports">
      <a className="b" href="https://app.powerbi.com/view?r=eyJrIjoiNTA2YzVmOGItMzJhZi00MjIyLWJkZWUtYzIxMWJjYWEyZGY5IiwidCI6IjJhMDA3MjhlLWYwZDAtNDBiNC1hNGU4LWNlNDMzZjNmYmNhNyIsImMiOjN9" target="_blank" rel="noopener noreferrer">Minority Participation Report</a> - This report provides enrollment, degrees awarded, and faculty information for various university peer group comparison.  Source information is from the Integrated Postsecondary Education Data System (IPEDS).
    </div>

    {/* <h3>Recreation Center</h3> */}
    <div className="reports">
      <p>
        <span className="b">University Recreation Center Report </span> - Reports developed at the request of the University Recreation Center.
      </p>
      <ul className="list-one">
        <li>
          <a className="b" href="https://app.powerbi.com/view?r=eyJrIjoiZmNjYWIzZmYtMTQ1Ni00ZDA4LTkxNjQtYTAzNDM1ZWRiZTdjIiwidCI6IjJhMDA3MjhlLWYwZDAtNDBiNC1hNGU4LWNlNDMzZjNmYmNhNyIsImMiOjN9" target="_blank" rel="noopener noreferrer">Recreation Center Student Employee Demographics Report</a> - A report highlighting the student employees within the Rec Center workforce.
        </li>
        <li>
          <a className="b" href="https://app.powerbi.com/view?r=eyJrIjoiOGQ5MGY0YjUtMDBhYi00ZDZlLThlNTgtNTQyMjgwYzFhNGM1IiwidCI6IjJhMDA3MjhlLWYwZDAtNDBiNC1hNGU4LWNlNDMzZjNmYmNhNyIsImMiOjN9" target="_blank" rel="noopener noreferrer">Recreation Center Utilization Report</a> - A report illustratating the use of Rec Center facilities by student.
        </li>
      </ul>
    </div>
  </Layout>
)

export default PublicReports
